import * as type from '../types/signUp';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestSignUp = actionCreator(type.REQUEST_SIGN_UP);
export var successSignUp = actionCreator(type.SUCCESS_SIGN_UP);
export var failureSignUp = actionCreator(type.FAILURE_SIGN_UP);